































import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import ui from '@/store/modules/ui';
import cart from '@/store/modules/cart';
import Sidebar from '@/components/UI/Sidebar.vue';
import { deleteCookie } from '@/commons/cookies';

@Component({
  components: {
    Sidebar,
  },
})
export default class Login extends Vue {
  private email: string = '';
  private password: string = '';
  private loading = false;

  private async login(email: string, password: string) {
    let promise: Promise<string>;

    const valid = await this.$validator.validateAll();
    if (!valid) {
      this.$validator.errors.all().forEach((error) => {
        this.$toast.err(error);
      });
      return;
    }
    this.loading = true;

    promise = user.login({ username: email, password, cartToken: cart.token });

    promise.then(() => {
      window.localStorage.removeItem('mage-cache-storage');
      deleteCookie('private_content_version');
      if (cart.isCartGuestFlagSet) {
        this.$router.push({ path: '/' });
      }
      cart.flagLoading({key: 'registrationlogin', value: true});
      window.location.reload();
    }).catch(() => {
      this.loading = false;
    });
  }

  private openForgotPassword() {
    ui.pushSidebar('forgotpassword');
  }

}
